{
  "ts": 1748353308,
  "tsCommit": 1748353271,
  "repoName": "WebSignup",
  "branchName": "prod",
  "rev": "7fc01a9",
  "ver": "20250527_1341_WebSignup_prod_7fc01a9",
  "env": "production",
  "isBranchDeployment": false
}
